import { render, staticRenderFns } from "./PxCamposCompraItemM8.vue?vue&type=template&id=5665d126&"
import script from "./PxCamposCompraItemM8.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemM8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports